import {FC} from 'react';
import {TermsFrench} from '../../components/termsAndPolicy/TermsFrench';

export const TermsOfUseFr: FC = () => {
    return <TermsFrench/>;
};
